export function usePlaceholderNum() {
  const placeholderNum = (minimum = 3, maximum = 12) => {
    const min = Math.ceil(minimum);
    const max = Math.floor(maximum);
    return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
  };
  return {placeholderNum};
}
